import dayjs from "dayjs";

// =====================
// Data & Duration
// =====================
const duration = {
  startDate: dayjs("2022-01-01"),
  endDate: dayjs().toDate(),
};

const infoData = [
  {
    admin: ["revenue"],
  },
  {
    raTeam: [
      "accounts",
      "contacts",
      "completedAccounts",
      "jobOpenings",
      "confirm",
      "positives",
      "jobsOnHold",
      "agreementDone",
      "placed",
      "jobClosed",
    ],
  },
  {
    bdmTeam: [
      "positives",
      "internalSubmission",
      "clientSubmission",
      "interviewScheduled",
      "agreementDone",
      "joined",
      "backout",
    ],
  },
  {
    recruiterTeam: [
      "activeJobs",
      "internalSubmissions",
      "clientSubmissions",
      "interviewScheduled",
      "closedJobs",
      "joined",
    ],
  },
];

// =====================
// Employees
// =====================
const employeeDetails = [
  // SuperAdmin
  {
    id: 1,
    name: "Omkar Sahu",
    team: "Admin",
    role: "Admin",
  },

  // RA Team
  { id: 2, name: "Aarav Sharma", team: "RA Team", role: "RA BU", managerId: 1 },
  {
    id: 3,
    name: "Ananya Gupta",
    team: "RA Team",
    role: "RA Manager",
    managerId: 2,
  },
  {
    id: 4,
    name: "Rohan Verma",
    team: "RA Team",
    role: "RA Manager",
    managerId: 2,
  },
  {
    id: 5,
    name: "Ishita Patel",
    team: "RA Team",
    role: "RA Lead",
    managerId: 3,
  },
  {
    id: 6,
    name: "Vivaan Kumar",
    team: "RA Team",
    role: "RA Lead",
    managerId: 4,
  },
  {
    id: 7,
    name: "Diya Singh",
    team: "RA Team",
    role: "RA Member",
    managerId: 5,
  },
  {
    id: 8,
    name: "Arjun Mehta",
    team: "RA Team",
    role: "RA Member",
    managerId: 5,
  },
  {
    id: 9,
    name: "Sanya Reddy",
    team: "RA Team",
    role: "RA Member",
    managerId: 6,
  },
  {
    id: 10,
    name: "Kabir Joshi",
    team: "RA Team",
    role: "RA Member",
    managerId: 6,
  },
  {
    id: 11,
    name: "Priya Nair",
    team: "RA Team",
    role: "RA Member",
    managerId: 6,
  },
  {
    id: 12,
    name: "Advait Desai",
    team: "RA Team",
    role: "RA Member",
    managerId: 6,
  },
  {
    id: 13,
    name: "Ayesha Kapoor",
    team: "RA Team",
    role: "RA Member",
    managerId: 5,
  },
  {
    id: 14,
    name: "Krishna Iyer",
    team: "RA Team",
    role: "RA Member",
    managerId: 5,
  },
  {
    id: 15,
    name: "Nisha Choudhary",
    team: "RA Team",
    role: "RA Member",
    managerId: 6,
  },

  // Recruiter Team
  {
    id: 16,
    name: "Aryan Malhotra",
    team: "Recruiter Team",
    role: "Recruiter BU",
    managerId: 1,
  },
  {
    id: 17,
    name: "Riya Saxena",
    team: "Recruiter Team",
    role: "Recruiter Manager",
    managerId: 16,
  },
  {
    id: 18,
    name: "Siddharth Bhatt",
    team: "Recruiter Team",
    role: "Recruiter Manager",
    managerId: 16,
  },
  {
    id: 19,
    name: "Tanya Rao",
    team: "Recruiter Team",
    role: "Recruiter Lead",
    managerId: 17,
  },
  {
    id: 20,
    name: "Devansh Kulkarni",
    team: "Recruiter Team",
    role: "Recruiter Lead",
    managerId: 18,
  },
  {
    id: 21,
    name: "Meera D'Souza",
    team: "Recruiter Team",
    role: "Recruiter Member",
    managerId: 19,
  },
  {
    id: 22,
    name: "Ansh Patil",
    team: "Recruiter Team",
    role: "Recruiter Member",
    managerId: 19,
  },
  {
    id: 23,
    name: "Kavya Bhat",
    team: "Recruiter Team",
    role: "Recruiter Member",
    managerId: 20,
  },
  {
    id: 24,
    name: "Shivansh Trivedi",
    team: "Recruiter Team",
    role: "Recruiter Member",
    managerId: 20,
  },
  {
    id: 25,
    name: "Tanvi Chatterjee",
    team: "Recruiter Team",
    role: "Recruiter Member",
    managerId: 20,
  },
  {
    id: 26,
    name: "Vihaan Nambiar",
    team: "Recruiter Team",
    role: "Recruiter Member",
    managerId: 20,
  },
  {
    id: 27,
    name: "Sakshi Verma",
    team: "Recruiter Team",
    role: "Recruiter Member",
    managerId: 19,
  },
  {
    id: 28,
    name: "Lakshya Mehra",
    team: "Recruiter Team",
    role: "Recruiter Member",
    managerId: 19,
  },
  {
    id: 29,
    name: "Radhika Pillai",
    team: "Recruiter Team",
    role: "Recruiter Member",
    managerId: 20,
  },

  // BDE Team
  {
    id: 30,
    name: "Yuvraj Raina",
    team: "BDE Team",
    role: "BDE BU",
    managerId: 1,
  },
  {
    id: 31,
    name: "Esha Jain",
    team: "BDE Team",
    role: "BDM Manager",
    managerId: 30,
  },
  {
    id: 32,
    name: "Aditya Khanna",
    team: "BDE Team",
    role: "BDM Manager",
    managerId: 30,
  },
  {
    id: 33,
    name: "Shreya Menon",
    team: "BDE Team",
    role: "BDM Lead",
    managerId: 31,
  },
  {
    id: 34,
    name: "Karan Anand",
    team: "BDE Team",
    role: "BDM Lead",
    managerId: 32,
  },
  {
    id: 35,
    name: "Mira Roy",
    team: "BDE Team",
    role: "BDE Member",
    managerId: 33,
  },
  {
    id: 36,
    name: "Arya Bhargava",
    team: "BDE Team",
    role: "BDE Member",
    managerId: 33,
  },
  {
    id: 37,
    name: "Saanvi Tiwari",
    team: "BDE Team",
    role: "BDE Member",
    managerId: 34,
  },
  {
    id: 38,
    name: "Ritvik Chawla",
    team: "BDE Team",
    role: "BDE Member",
    managerId: 34,
  },
  {
    id: 39,
    name: "Aadhya Sethi",
    team: "BDE Team",
    role: "BDE Member",
    managerId: 34,
  },
  {
    id: 40,
    name: "Darsh Malhotra",
    team: "BDE Team",
    role: "BDE Member",
    managerId: 33,
  },
  {
    id: 41,
    name: "Anika Reddy",
    team: "BDE Team",
    role: "BDE Member",
    managerId: 34,
  },
  {
    id: 42,
    name: "Arnav Joshi",
    team: "BDE Team",
    role: "BDE Member",
    managerId: 34,
  },
  {
    id: 43,
    name: "Ira Kapoor",
    team: "BDE Team",
    role: "BDE Member",
    managerId: 33,
  },
];

// =====================
// Generate Daily Data
// =====================
const generateDailyData = (employeeDetails, infoData, duration) => {
  const start = dayjs(duration.startDate).toDate();
  const end = dayjs(duration.endDate).toDate();

  const teamKeyMap = {
    "RA Team": "raTeam",
    "Recruiter Team": "recruiterTeam",
    "BDE Team": "bdmTeam",
  };

  const getTeamFields = (team) => {
    const key = teamKeyMap[team];
    if (!key) return [];
    const teamData = infoData.find((d) => d[key] !== undefined);
    return teamData ? teamData[key] : [];
  };

  const allData = [];

  employeeDetails.forEach((emp) => {
    //if (emp.managerId === 0) return; // Skip level 4

    const fields = getTeamFields(emp.team);

    // Create a new Date object for each employee to avoid mutation issues
    for (
      let d = new Date(start);
      d <= end;
      d = new Date(d.setDate(d.getDate() + 1))
    ) {
      const fmtLocal = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${day}`;
      };
      const dailyRecord = {
        employeeId: emp.id,
        name: emp.name,
        team: emp.team,
        managerId: emp.managerId,
        role: emp.role,
        date: fmtLocal(d),
        infoData: {},
      };
      const todayStr = fmtLocal(new Date());
      const isToday = dailyRecord.date === todayStr;

      fields.forEach((field) => {
        if (field === "accounts") {
          dailyRecord.infoData[field] =
            Math.floor(Math.random() * (130 - 50 + 1)) + 50;
        } else if (field === "completedAccounts") {
          dailyRecord.infoData[field] = dailyRecord.infoData["accounts"]
            ? Math.floor(Math.random() * (dailyRecord.infoData["accounts"] + 1))
            : 0;
        } else if (field === "contacts") {
          const acc = dailyRecord.infoData["accounts"] || 0;
          const comp = Math.min(
            acc,
            dailyRecord.infoData["completedAccounts"] || 0
          );
          const pending = Math.max(0, acc - comp);
          const minContacts = comp * 5 + pending * 1;
          const maxContacts = comp * 5 + pending * 4;
          dailyRecord.infoData[field] = acc
            ? Math.floor(Math.random() * (maxContacts - minContacts + 1)) +
              minContacts
            : 0;
        } else if (field === "jobOpenings") {
          dailyRecord.infoData[field] = dailyRecord.infoData["accounts"]
            ? Math.floor(Math.random() * (dailyRecord.infoData["accounts"] + 1))
            : 0;
        } else if (field === "confirm") {
          dailyRecord.infoData[field] = dailyRecord.infoData["jobOpenings"]
            ? Math.floor(
                Math.random() * (dailyRecord.infoData["jobOpenings"] + 1)
              )
            : 0;
        } else if (field === "positives" || field === "Positives") {
          const confirmVal = dailyRecord.infoData["confirm"] || 0;
          dailyRecord.infoData[field] = confirmVal
            ? Math.floor(Math.random() * (confirmVal + 1))
            : Math.floor(Math.random() * 11);
        } else if (field === "jobsOnHold") {
          dailyRecord.infoData[field] = dailyRecord.infoData["jobOpenings"]
            ? Math.floor(
                Math.random() * (dailyRecord.infoData["jobOpenings"] + 1)
              )
            : 0;
        } else if (field === "agreementDone") {
          const posVal =
            (dailyRecord.infoData["positives"] ??
              dailyRecord.infoData["Positives"]) ||
            0;
          dailyRecord.infoData[field] = posVal
            ? Math.floor(Math.random() * (posVal + 1))
            : 0;
        } else if (field === "placed") {
          dailyRecord.infoData[field] = dailyRecord.infoData["agreementDone"]
            ? Math.floor(
                Math.random() * (dailyRecord.infoData["agreementDone"] + 1)
              )
            : 0;
        } else if (field === "jobClosed") {
          dailyRecord.infoData[field] = dailyRecord.infoData["jobOpenings"]
            ? Math.floor(
                Math.random() * (dailyRecord.infoData["jobOpenings"] + 1)
              )
            : 0;
        } else if (field === "internalSubmission") {
          const posVal =
            (dailyRecord.infoData["positives"] ??
              dailyRecord.infoData["Positives"]) ||
            0;
          dailyRecord.infoData[field] =
            posVal + (Math.floor(Math.random() * 11) + 5);
        } else if (field === "clientSubmission") {
          const internal = dailyRecord.infoData["internalSubmission"] || 0;
          dailyRecord.infoData[field] = internal
            ? Math.floor(Math.random() * (internal + 1))
            : 0;
        } else if (field === "interviewScheduled") {
          const client =
            dailyRecord.infoData["clientSubmission"] ??
            dailyRecord.infoData["clientSubmissions"] ??
            0;
          dailyRecord.infoData[field] = client
            ? Math.floor(Math.random() * (client + 1))
            : 0;
        } else if (field === "joined") {
          const agree = dailyRecord.infoData["agreementDone"] || 0;
          dailyRecord.infoData[field] = agree
            ? Math.floor(Math.random() * (agree + 1))
            : dailyRecord.infoData["interviewScheduled"]
            ? Math.floor(
                Math.random() * (dailyRecord.infoData["interviewScheduled"] + 1)
              )
            : 0;
        } else if (field === "backout") {
          const joined = dailyRecord.infoData["joined"] || 0;
          dailyRecord.infoData[field] = joined
            ? Math.floor(Math.random() * (Math.min(joined, 5) + 1))
            : 0;
        } else if (field === "activeJobs") {
          dailyRecord.infoData[field] =
            Math.floor(Math.random() * (60 - 10 + 1)) + 10;
        } else if (field === "internalSubmissions") {
          const active = dailyRecord.infoData["activeJobs"] || 0;
          const min = active * 3;
          const max = active * 8;
          dailyRecord.infoData[field] = active
            ? Math.floor(Math.random() * (max - min + 1)) + min
            : 0;
        } else if (field === "clientSubmissions") {
          const internal = dailyRecord.infoData["internalSubmissions"] || 0;
          dailyRecord.infoData[field] = internal
            ? Math.floor(Math.random() * (internal + 1))
            : 0;
        } else if (field === "closedJobs") {
          const active = dailyRecord.infoData["activeJobs"] || 0;
          dailyRecord.infoData[field] = active
            ? Math.floor(Math.random() * (active + 1))
            : 0;
        } else {
          dailyRecord.infoData[field] = Math.floor(Math.random() * 6);
        }
      });

      allData.push(dailyRecord);
    }
  });

  return allData;
};

// =====================
// Filter Data by Employee Hierarchy with Duration
// =====================
const getFilteredDataWithHierarchy = (dailyData, employeeId, duration) => {
  // Normalize to YYYY-MM-DD strings to avoid timezone issues
  const startStr = dayjs(duration.startDate).format("YYYY-MM-DD");
  const endStr = dayjs(duration.endDate).format("YYYY-MM-DD");

  // Recursive function to get all subordinate IDs
  const getSubordinateIdsFromData = (employeeId) => {
    const directSubs = [
      ...new Set(
        dailyData
          .filter((d) => d.managerId === employeeId)
          .map((d) => d.employeeId)
      ),
    ];

    let allSubs = [...directSubs];
    directSubs.forEach((subId) => {
      allSubs = allSubs.concat(getSubordinateIdsFromData(subId));
    });

    return allSubs;
  };

  const hierarchyIds = [employeeId, ...getSubordinateIdsFromData(employeeId)];

  // Filter records by hierarchy and inclusive duration using string compare
  const hierarchyData = dailyData.filter(
    (d) =>
      hierarchyIds.includes(d.employeeId) &&
      d.date >= startStr &&
      d.date <= endStr
  );

  return {
    employee: hierarchyData.filter((d) => d.employeeId === employeeId),
    subordinates: hierarchyData.filter((d) => d.employeeId !== employeeId),
  };
};

// =====================
// Helper Functions
// =====================

// Get unique teams
const getUniqueTeams = (employeeDetails) => {
  return [...new Set(employeeDetails.map((emp) => emp.team))];
};

// Get unique roles
const getUniqueRoles = (employeeDetails) => {
  return [...new Set(employeeDetails.map((emp) => emp.role))];
};

// Get employees by role
const getEmployeesByRole = (employeeDetails, role) => {
  return employeeDetails.filter((emp) => emp.role === role);
};

// Get employees by team
const getEmployeesByTeam = (employeeDetails, team) => {
  return employeeDetails.filter((emp) => emp.team === team);
};

// =====================
// Usage & Initialization
// =====================
const dailyData = generateDailyData(employeeDetails, infoData, duration);

// console.log("Total daily records generated:", dailyData.length);
// console.log("Unique teams:", getUniqueTeams(employeeDetails));
// console.log("Unique roles:", getUniqueRoles(employeeDetails));

// now time to generate the data for the charts
const buildDateReport = (rowsOrObj, keys, usersId) => {
  const isObj =
    !Array.isArray(rowsOrObj) &&
    rowsOrObj &&
    (rowsOrObj.employee || rowsOrObj.subordinates);
  const ids = Array.isArray(usersId)
    ? new Set(usersId)
    : usersId != null
    ? new Set([usersId])
    : null;
  const filterRows = (rows) =>
    ids ? rows.filter((r) => ids.has(r.employeeId)) : rows;
  const baseAllRows = Array.isArray(rowsOrObj)
    ? rowsOrObj
    : [...(rowsOrObj?.employee || []), ...(rowsOrObj?.subordinates || [])];
  const allRows = filterRows(baseAllRows);
  const dates = Array.from(new Set(allRows.map((r) => r.date))).sort(
    (a, b) => new Date(a) - new Date(b)
  );
  const sumSeriesForRows = (rows) =>
    keys.map((key) => ({
      name: key,
      data: dates.map((dt) =>
        filterRows(rows)
          .filter((r) => r.date === dt)
          .reduce((sum, r) => sum + (r.infoData?.[key] || 0), 0)
      ),
    }));
  if (!isObj) {
    return { categories: dates, series: sumSeriesForRows(allRows) };
  }
  const employeeRows = filterRows(rowsOrObj.employee || []);
  const subordinateRows = filterRows(rowsOrObj.subordinates || []);
  const employeeSeries = sumSeriesForRows(employeeRows);
  const groupedSubs = subordinateRows.reduce((acc, r) => {
    const id = r.employeeId;
    if (!acc[id]) acc[id] = { name: r.name || String(id), rows: [] };
    acc[id].rows.push(r);
    return acc;
  }, {});
  const subordinatesSeries = Object.values(groupedSubs).map(
    ({ name, rows }) => ({
      name,
      series: sumSeriesForRows(rows),
    })
  );
  return {
    categories: dates,
    series: { employee: employeeSeries, subordinates: subordinatesSeries },
  };
};

const buildDateReportTotal = (rowsOrObj, keys, usersId) => {
  const isObj =
    !Array.isArray(rowsOrObj) &&
    rowsOrObj &&
    (rowsOrObj.employee || rowsOrObj.subordinates);
  const ids = Array.isArray(usersId)
    ? new Set(usersId)
    : usersId != null
    ? new Set([usersId])
    : null;
  const filterRows = (rows) =>
    ids ? rows.filter((r) => ids.has(r.employeeId)) : rows;
  const normalizeKey = (k) =>
    k === "positives" ? ["positives", "Positives"] : [k];
  const sumTotalsForRows = (rows) =>
    keys.map((key) => {
      const variants = normalizeKey(key);
      return (filterRows(rows) || []).reduce((sum, r) => {
        return (
          sum + variants.reduce((inner, v) => inner + (r.infoData?.[v] || 0), 0)
        );
      }, 0);
    });
  const totalsMapForRows = (rows) =>
    keys.reduce((acc, key) => {
      const variants = normalizeKey(key);
      acc[key] = (filterRows(rows) || []).reduce((sum, r) => {
        return (
          sum + variants.reduce((inner, v) => inner + (r.infoData?.[v] || 0), 0)
        );
      }, 0);
      return acc;
    }, {});
  if (!isObj) {
    const rows = filterRows(rowsOrObj || []);
    return {
      categories: keys,
      series: sumTotalsForRows(rows),
      fullData: totalsMapForRows(rows),
    };
  }
  const employeeRows = filterRows(rowsOrObj.employee || []);
  const subordinateRows = filterRows(rowsOrObj.subordinates || []);
  const employeeSeries = sumTotalsForRows(employeeRows);
  const employeeFullData = totalsMapForRows(employeeRows);
  const groupedSubs = subordinateRows.reduce((acc, r) => {
    const id = r.employeeId;
    if (!acc[id]) acc[id] = { name: r.name || String(id), rows: [] };
    acc[id].rows.push(r);
    return acc;
  }, {});
  const subordinatesSeries = Object.values(groupedSubs).map(
    ({ name, rows }) => ({
      name,
      series: sumTotalsForRows(rows),
    })
  );
  const subordinatesFullData = Object.values(groupedSubs).map(
    ({ name, rows }) => ({
      name,
      values: totalsMapForRows(rows),
    })
  );
  return {
    categories: keys,
    series: { employee: employeeSeries, subordinates: subordinatesSeries },
    fullData: {
      employee: employeeFullData,
      subordinates: subordinatesFullData,
    },
  };
};



const buildGroupedStackSeriesByTeam = (rowsOrObj, infoTypes, usersId, team) => {
  const isObj =
    !Array.isArray(rowsOrObj) &&
    rowsOrObj &&
    (rowsOrObj.employee || rowsOrObj.subordinates);
  const ids = Array.isArray(usersId)
    ? new Set(usersId)
    : usersId != null
    ? new Set([usersId])
    : null;
  const normalizeKey = (k) =>
    k === "positives" ? ["positives", "Positives"] : [k];
  const filterRows = (rows) => {
    let out = rows || [];
    if (team) out = out.filter((r) => r.team === team);
    if (ids) out = out.filter((r) => ids.has(r.employeeId));
    return out;
  };
  const baseRows = Array.isArray(rowsOrObj)
    ? rowsOrObj
    : [...(rowsOrObj?.employee || []), ...(rowsOrObj?.subordinates || [])];
  const rows = filterRows(baseRows);
  const categories = Array.from(new Set(rows.map((r) => r.date))).sort(
    (a, b) => new Date(a) - new Date(b)
  );
  const byEmp = rows.reduce((acc, r) => {
    const id = r.employeeId;
    const name = r.name || String(id);
    if (!acc[id]) acc[id] = { name, rows: [] };
    acc[id].rows.push(r);
    return acc;
  }, {});
  const series = [];
  Object.values(byEmp).forEach(({ name, rows }) => {
    const totalsByType = {};
    (infoTypes || []).forEach((t) => (totalsByType[t] = new Map()));
    rows.forEach((rec) => {
      const dk = rec.date;
      (infoTypes || []).forEach((t) => {
        const variants = normalizeKey(t);
        const v = variants.reduce(
          (sum, k) => sum + (rec.infoData?.[k] || 0),
          0
        );
        totalsByType[t].set(dk, (totalsByType[t].get(dk) || 0) + v);
      });
    });
    (infoTypes || []).forEach((t) => {
      const niceName =
        t === "jobOpenings"
          ? "Job Openings"
          : t === "contacts"
          ? "Contacts"
          : t === "accounts"
          ? "Accounts"
          : t === "confirm"
          ? "Confirm"
          : String(t);
      const data = categories.map((k) => totalsByType[t].get(k) || 0);
      series.push({ name: niceName, group: name, data });
    });
  });
  return { categories, series };
};

const buildDateReportTotalByTeam = (rowsOrObj, keys, usersId, team) => {
  const isObj =
    !Array.isArray(rowsOrObj) &&
    rowsOrObj &&
    (rowsOrObj.employee || rowsOrObj.subordinates);
  const ids = Array.isArray(usersId)
    ? new Set(usersId)
    : usersId != null
    ? new Set([usersId])
    : null;
  const filterRows = (rows) => {
    let out = rows || [];
    if (team) out = out.filter((r) => r.team === team);
    if (ids) out = out.filter((r) => ids.has(r.employeeId));
    return out;
  };
  const normalizeKey = (k) =>
    k === "positives" ? ["positives", "Positives"] : [k];
  const sumTotalsForRows = (rows) =>
    keys.map((key) => {
      const variants = normalizeKey(key);
      return (filterRows(rows) || []).reduce((sum, r) => {
        return (
          sum + variants.reduce((inner, v) => inner + (r.infoData?.[v] || 0), 0)
        );
      }, 0);
    });
  const totalsMapForRows = (rows) =>
    keys.reduce((acc, key) => {
      const variants = normalizeKey(key);
      acc[key] = (filterRows(rows) || []).reduce((sum, r) => {
        return (
          sum + variants.reduce((inner, v) => inner + (r.infoData?.[v] || 0), 0)
        );
      }, 0);
      return acc;
    }, {});
  if (!isObj) {
    const rows = filterRows(rowsOrObj || []);
    return {
      categories: keys,
      series: sumTotalsForRows(rows),
      fullData: totalsMapForRows(rows),
    };
  }
  const employeeRows = filterRows(rowsOrObj.employee || []);
  const subordinateRows = filterRows(rowsOrObj.subordinates || []);
  const employeeSeries = sumTotalsForRows(employeeRows);
  const employeeFullData = totalsMapForRows(employeeRows);
  const groupedSubs = subordinateRows.reduce((acc, r) => {
    const id = r.employeeId;
    if (!acc[id]) acc[id] = { name: r.name || String(id), rows: [] };
    acc[id].rows.push(r);
    return acc;
  }, {});
  const subordinatesSeries = Object.values(groupedSubs).map(
    ({ name, rows }) => ({
      name,
      series: sumTotalsForRows(rows),
    })
  );
  const subordinatesFullData = Object.values(groupedSubs).map(
    ({ name, rows }) => ({
      name,
      values: totalsMapForRows(rows),
    })
  );
  return {
    categories: keys,
    series: { employee: employeeSeries, subordinates: subordinatesSeries },
    fullData: {
      employee: employeeFullData,
      subordinates: subordinatesFullData,
    },
  };
};



const getSubordinates = (employeeId) => {
  const byManager = employeeDetails.reduce((acc, emp) => {
    (acc[emp.managerId] = acc[emp.managerId] || []).push(emp);
    return acc;
  }, {});
  const seen = new Set();
  const collect = (id) => {
    const direct = byManager[id] || [];
    const result = [];
    direct.forEach((emp) => {
      if (seen.has(emp.id)) return;
      seen.add(emp.id);
      result.push({ label: emp.name || String(emp.id), id: emp.id });
      result.push(...collect(emp.id));
    });
    return result;
  };
  return collect(employeeId);
};

// =====================
// Exports
// =====================
export {
  duration,
  employeeDetails,
  dailyData,
  infoData,
  getFilteredDataWithHierarchy,
  getUniqueTeams,
  getUniqueRoles,
  getEmployeesByRole,
  getEmployeesByTeam,
  buildDateReport,
  buildDateReportTotal,
  buildDateReportTotalByTeam,
  buildGroupedStackSeriesByTeam,
  getSubordinates,
};
